import React, { useEffect, useState } from "react";
import { Form, Input, message, Row, Col, Select } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch, InputDate, InputTime } from "@comps/components"
import { makeRequest } from "@utils/helpers";
import { createDataReq } from "../requests";
import { Commons, Const, Validations } from "../../../constants";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { masterTooltips } from "../../../../common/masterTooltips";

const langKey = Const["scheduler"].lngKey

const fieldLabel = makeFieldLabel(masterTooltips.scheduler, { namespace: "scheduler", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createCode";

const CreateScheduler = (props) => {
  const [loader, setLoader] = useState(false);
  const [saving, setSaving] = useState(false)
  const [type, setType] = useState('one_time')
  const [repeatType, setRepeatType] = useState('')
  const [occEveryType, setOccEveryType] = useState(0)
  const [isOnce, setIsOnce] = useState(0)

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const onSubmit = (data) => {
    //format each date
    if (data.one_time_date) {
      data.one_time_date = data.one_time_date.format("YYYY-MM-DD")
    }
    if (data.one_time_time) {
      //set one_time_date to one_time_time
      //data.one_time_time = data.one_time_time.format("HH:mm:ss")
    }
    if (data.occur_once_time) {
      //data.occur_once_time = data.occur_once_time.format("HH:mm:ss")
    }
    if (data.recur_duration_start_date) {
      data.recur_duration_start_date = data.recur_duration_start_date.format("YYYY-MM-DD")
    }
    if (data.recur_duration_end_date) {
      data.recur_duration_end_date = data.recur_duration_end_date.format("YYYY-MM-DD")
    }
    if (data.occur_every_start_time) {
      //data.occur_every_start_time = data.occur_every_start_time.format("HH:mm:ss")
    }
    if (data.occur_every_end_time) {
      //data.occur_every_end_time = data.occur_every_end_time.format("HH:mm:ss")
    }
    const payload = { scheduler: data };
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
    setSaving(true)
  }

  const onSuccess = (data, res) => {
    setSaving(false)
    message.success("Saved successfully");
    props.onCompleted(data);
  }

  const onError = (err, res) => {
    setSaving(false)
    message.error(res.response.data.message);
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1600 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit }>
        <Row gutter={ 30 }>
          <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
            <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name", trans(`${langKey}.name`)) }
              className="da-mb-16"

            >
              <InputText placeholder={ trans(`${langKey}.name`) } />
            </Form.Item>

          </Col>
          <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
            <Form.Item name="type" rules={ rules.type } label={ fieldLabel("type", trans(`${langKey}.type`)) }
              className="da-mb-16"
              initialValue={ type }
            >
              <SelectWithSearch
                options={ props.types }
                placeholder={ trans(`${langKey}.type`) }
                onChange={ (value) => {
                  setType(value)
                } }

              />
            </Form.Item>
          </Col>
          <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
            <Form.Item name="is_enabled" rules={ rules.is_enabled } label={ fieldLabel("is_enabled", trans(`${langKey}.is_enabled`)) }
              className="da-mb-16"

            >
              <SelectWithSearch
                options={ [
                  {
                    value: 1,
                    label: 'Yes'
                  },
                  {
                    value: 0,
                    label: 'No'
                  }
                ] }
                placeholder={ trans(`${langKey}.is_enabled`) } />
            </Form.Item>
          </Col>

          {
            type === 'one_time' &&
            <>
              <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                <Form.Item name="one_time_date" rules={ rules.one_time_date } label={ fieldLabel("one_time_date", trans(`${langKey}.one_time_date`)) }
                  className="da-mb-16"

                >
                  <InputDate

                  />
                </Form.Item>
              </Col>
              <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                <Form.Item name="one_time_time" rules={ rules.one_time_time } label={ fieldLabel("one_time_time", trans(`${langKey}.one_time_time`)) }
                  className="da-mb-16"

                >
                  <InputTime

                  />
                </Form.Item>
              </Col>

            </>

          }

          {
            type === 'recurring' &&
            <>
              <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                <Form.Item name="recurr_type" rules={ rules.recurr_type } label={ fieldLabel("recurr_type", trans(`${langKey}.recurr_type`)) }
                  className="da-mb-16"

                >
                  <SelectWithSearch
                    options={ props.repeatTypes }
                    placeholder={ trans(`${langKey}.recurr_type`) } />
                </Form.Item>
              </Col>
              <Col lg={ 24 } sm={ 24 } xs={ 12 } className="da-mb-16">
                <Form.Item name="is_once" rules={ rules.is_once } label={ fieldLabel("is_once", trans(`${langKey}.is_once`)) }
                  className="da-mb-16"
                  initialValue={ isOnce }
                >
                  <SelectWithSearch
                    options={ [
                      {
                        value: 0,
                        label: 'Occurs Every'
                      },
                      {
                        value: 1,
                        label: 'Occurs Once'
                      }
                    ] }
                    placeholder={ trans(`${langKey}.is_once`) }

                    onChange={ (value) => {
                      setIsOnce(value)
                    } }
                  />
                </Form.Item>
              </Col>

              {
                !isOnce ?
                  <>


                    <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                      <Form.Item name="occur_every_number" rules={ rules.occur_every_number } label={ fieldLabel("occur_every_number", trans(`${langKey}.occur_every_number`)) }
                        className="da-mb-16"
                      >
                        <InputText
                          type="number"
                          onWheel={ (e) => e.target.blur() }

                        />
                      </Form.Item>
                    </Col>
                    <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                      <Form.Item name="recurr_type" rules={ rules.recurr_type } label={ fieldLabel("recurr_type", trans(`${langKey}.recurr_type`)) }
                        className="da-mb-16"
                      >
                        <SelectWithSearch
                          options={ props.occurEveryTypes }
                          placeholder={ trans(`${langKey}.recurr_type`) } />
                      </Form.Item>
                    </Col>

                    <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                      <Form.Item name="recur_duration_start_date" rules={ rules.recur_duration_start_date } label={ fieldLabel("recur_duration_start_date", trans(`${langKey}.recur_duration_start_date`)) }
                        className="da-mb-16"

                      >
                        <InputDate

                        />
                      </Form.Item>
                    </Col>
                    <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                      <Form.Item name="occur_every_start_time" rules={ rules.occur_every_start_time } label={ fieldLabel("occur_every_start_time", trans(`${langKey}.occur_every_start_time`)) }
                        className="da-mb-16"
                      >
                        <InputTime
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                      <Form.Item name="recur_duration_end_date" rules={ rules.recur_duration_end_date } label={ fieldLabel("recur_duration_end_date", trans(`${langKey}.recur_duration_end_date`)) }
                        className="da-mb-16"

                      >
                        <InputDate

                        />
                      </Form.Item>
                    </Col>
                    <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                      <Form.Item name="occur_every_end_time" rules={ rules.occur_every_end_time } label={ fieldLabel("occur_every_end_time", trans(`${langKey}.occur_every_end_time`)) }
                        className="da-mb-16"
                      >
                        <InputTime
                        />
                      </Form.Item>
                    </Col>


                  </> :
                  <>
                    <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                      <Form.Item name="occur_once_time" rules={ rules.occur_once_time } label={ fieldLabel("occur_once_time", trans(`${langKey}.occur_once_time`)) }
                        className="da-mb-16"

                      >
                        <InputTime

                        />
                      </Form.Item>
                    </Col>
                    <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                      <Form.Item name="recur_duration_start_date" rules={ rules.recur_duration_start_date } label={ fieldLabel("recur_duration_start_date", trans(`${langKey}.recur_duration_start_date`)) }
                        className="da-mb-16"

                      >
                        <InputDate

                        />
                      </Form.Item>
                    </Col>
                    <Col lg={ 12 } sm={ 24 } xs={ 12 } className="da-mb-16">
                      <Form.Item name="recur_duration_end_date" rules={ rules.recur_duration_end_date } label={ fieldLabel("recur_duration_end_date", trans(`${langKey}.recur_duration_end_date`)) }
                        className="da-mb-16"

                      >
                        <InputDate

                        />
                      </Form.Item>
                    </Col>
                  </>
              }
            </>
          }
        </Row>

      </Form>
    </ModalComponent>
  )
}

export default CreateScheduler

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.req`) },
  ],
  type: [
    { required: true, message: trans(`${langKey}.type.req`) },
  ],
  is_enabled: [
    { required: true, message: trans(`${langKey}.is_enabled.req`) },
  ],
  one_time_date: [
    { required: true, message: trans(`${langKey}.one_time_date.req`) },
  ],
  one_time_time: [
    { required: true, message: trans(`${langKey}.one_time_time.req`) },
  ],
  occur_once_time: [
    { required: true, message: trans(`${langKey}.occur_once_time.req`) },
  ],
  occur_every_start_time: [
    { required: true, message: trans(`${langKey}.occur_every_start_time.req`) },
  ],
  occur_every_end_time: [
    { required: true, message: trans(`${langKey}.occur_every_end_time.req`) },
  ],
  recur_duration_start_date: [
    { required: true, message: trans(`${langKey}.recur_duration_start_date.req`) },
  ],
  recur_duration_end_date: [
    { required: true, message: trans(`${langKey}.recur_duration_end_date.req`) },
  ],
  recurr_type: [
    { required: true, message: trans(`${langKey}.recurr_type.req`) },
  ],
  is_once: [
    { required: true, message: trans(`${langKey}.is_once.req`) },
  ],
  occur_every_type: [
    { required: true, message: trans(`${langKey}.occur_every_type.req`) },
  ],
  recurr_frequency: [
    { required: true, message: trans(`${langKey}.recurr_frequency.req`) },
  ],
  occur_every_number: [
    { required: true, message: trans(`${langKey}.occur_every_number.req`) },
  ],

};

const formLayout = {
  // layout: "horizontal",
  labelCol: { span: 5 },
  wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}